module.exports = __webpack_public_path__ + "img/sos_deeplink.4f7be8b2.svg";